//=require node_modules/bootstrap/dist/js/bootstrap.bundle.min.js
//=require node_modules/select2/dist/js/select2.min.js
//=require node_modules/tabbable/dist/index.umd.js
//=require node_modules/focus-trap/dist/focus-trap.umd.js

//=require node_modules/slick-slider/slick/slick.min.js